/**
 * Всплывающие уведомления в правом нижнем углу (#notify).
 */
const TTL = 3200;

export function notify( message, type = '' ) {

    const root = document.getElementById('notify');

    if( ! root )
        return;

    const item = document.createElement('div');

    item.className   = 'notify-item' + ( type ? ' is-' + type : '' );
    item.textContent = message;

    root.appendChild( item );

    setTimeout( () => item.remove(), TTL );
}
